import React, { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import RouteService from '../../app/service/routeService';
import AuthContext from '../../main/authenticationProvider';
import Map from '../../components/map';
import { Card, Col, Input, Row, Select, Form, Modal as Dialog } from 'antd';
import { Button } from '../../components';
import {
    DownloadOutlined,
    DeleteOutlined,
    SearchOutlined,
    SaveOutlined,
    PlusOutlined,
    LeftOutlined,
    EnvironmentOutlined,
    NodeIndexOutlined
} from '@ant-design/icons';
import { messageError, messageSuccess, messageAlert } from '../../components/toastr';
import Loading from "../../components/loading";
import AppLayout from "../../components/layouts/AppLayout/index";
import LinkRoute from "../../views/linkRoute";
import PlateService from '../../app/service/plateService';
import { Button as ButtonAntd } from 'antd';

class CreateRoute extends PureComponent {
    constructor(props) {
        super(props);

        this.serviceRoute = new RouteService();
        this.auth = new AuthContext();
        this.servicePlate = new PlateService();

        this.state = {
            componentKey: 0,
            latitude: -15.7801,
            longitude: -47.9292,
            zoom: 4,
            directions: null,
            nome: "",
            inicio: "",
            fim: "",
            routes: [],
            allRoutes: [],
            points: [],
            allPoints: [],
            newPoint: [],
            triangleCoords: null,
            routeSelected: null,
            pointSelected: null,
            modalRemove: false,
            typeRemove: null,
            draggable: false,
            loading: false,
            loadingMap: false,
            loadingSaveRoute: false,
            loadingRemoveRoute: false,
            loadingRemovePoint: false,
            linkRouteButton: false,
            linkRoutePlate: false,
            plate: '',
            createNewRoute: false,
            addNewPoint: false,
            sizeListWaypoints: 0,
        }

        this.createRouteForm = React.createRef();

        this.getUpdatedPoints = (updatedPoints) => {
            let vetPoints = [];
            vetPoints.push({ value: 0, label: "Nenhum" });
            updatedPoints.map((elem, index) => {
                vetPoints.push({
                    value: index + 1,
                    label: `Lat: ${elem[1].toFixed(4)}, Long: ${elem[0].toFixed(4)}`
                })
            });
            vetPoints.push({ value: vetPoints.length + 1, label: "Todos" });
            this.setState({
                points: vetPoints,
                allPoints: updatedPoints,
                sizeListWaypoints: vetPoints.length
            })
        }

        this.getRouteById = id => {
            this.serviceRoute
                .getRouteInformationByVehicle(id)
                .then(response => {
                    let opt = [];
                    opt.push({
                        value: 0,
                        label: "Nenhum"
                    });
                    response.data.data.waypoints.forEach((item, index) => {
                        opt.push({
                            value: index + 1,
                            label: "Lat: " + item[1].toString().substring(0, 8) + ", Long: " + item[0].toString().substring(0, 8)
                        });
                    });
                    opt.push({
                        value: opt.length + 1,
                        label: "Todos"
                    });

                    this.setState({
                        directions: response.data.data.gmaps,
                        draggable: false,
                        loading: false,
                        modalRemove: false,
                        points: opt,
                        allPoints: response.data.data.waypoints,
                        sizeListWaypoints: opt.length
                    });
                })
                .catch(erros => {
                    if (erros.response && erros.response.status === 401) {
                        this.auth.endSession();
                        this.props.history.push('/login');
                    }
                })
        };

        this.getRoutes = () => {
            this.serviceRoute
                .getRoutes()
                .then(response => {
                    let opt = [];

                    response.data.data.forEach(item => {
                        opt.push({
                            value: item.routeId,
                            label: item.name
                        });
                    });

                    this.setState({
                        routes: opt,
                        allRoutes: response.data.data,
                        loading: false,
                    });
                })
                .catch(erros => {
                    if (erros.response && erros.response.status === 401) {
                        this.auth.endSession();
                        this.props.history.push('/login');
                    }
                    this.setState({
                        loading: false,
                    });
                })
        };

        this.componentDidMount = () => {
            this.getRoutes();
        };

        this.mountRoute = $event => {
            $event.preventDefault();

            this.setState({
                loadingMap: true
            });

            const DirectionsService = new window.google.maps.DirectionsService();

            DirectionsService.route({
                origin: this.state.inicio,
                destination: this.state.fim,
                travelMode: window.google.maps.TravelMode.DRIVING,
            }, (result, status) => {
                if (status === window.google.maps.DirectionsStatus.OK) {
                    this.setState({
                        directions: result,
                        draggable: true,
                        loadingMap: false
                    });
                } else {
                    this.setState({
                        loadingMap: false
                    });
                    messageAlert("Falha ao traçar a rota (caminho não encontrado).");
                }
            });
        };

        this.removeRoute = $event => {

            this.setState({
                loadingRemoveRoute: true
            });

            $event.preventDefault();
            this.serviceRoute
                .removeRoute(this.state.routeSelected.routeId)
                .then(response => {
                    if (response.data.status !== 200) {
                        messageError("ERRO! Falha no processamento desta ação, favor repetir o processo.");
                    } else {
                        messageSuccess("Rota excluída com sucesso!");
                        this.createRouteForm.current.setFieldsValue({
                            rotas: null,
                            nome: null,
                            inicio: null,
                            fim: null,
                            pontos: null
                        });

                        this.setState({
                            nome: "",
                            inicio: "",
                            fim: "",
                            routeSelected: null,
                            directions: null,
                            modalRemove: false,
                            draggable: false,
                            loadingRemoveRoute: false
                        }, () => {
                            this.getRoutes();
                        });
                    }
                })
                .catch(erros => {
                    this.setState({
                        loadingRemoveRoute: false
                    });

                    if (erros.response.status === 401) {
                        this.auth.endSession();
                        this.props.history.push('/login');
                    }
                })
        };

        this.updateWayPoints = (routeSelected, pointSelected) => {
            const allPoints = this.state.allPoints.filter(point =>
                !pointSelected.some(p => p === point)
            );
            this.setState({
                allPoints: allPoints
            });

            this.serviceRoute
                .updateWayPoints({
                    "routeId": routeSelected.routeId,
                    "waypoints": allPoints,
                })
                .then(response => {
                    if (response.data.status !== 200) {
                        messageError("ERRO! Falha no processamento desta ação, favor repetir o processo.");
                    } else {
                        messageSuccess("Ponto excluído com sucesso!");

                        let opt = [];

                        response.data.data.forEach((item, index) => {
                            opt.push({
                                value: index,
                                label: "Lat: " + item[1].toString().substring(0, 8) + ", Long: " + item[0].toString().substring(0, 8)
                            });
                        });

                        this.getRouteById(routeSelected.routeId);

                        this.setState({
                            loadingRemovePoint: false,
                            pointSelected: null
                        });
                    }
                })
                .catch(erros => {
                    messageError("ERRO! Falha no processamento desta ação, favor repetir o processo.");
                    this.setState({
                        loadingRemovePoint: false,
                        pointSelected: null
                    });
                    if (erros && erros.response && erros.response.status === 401) {
                        this.auth.endSession();
                        this.props.history.push('/login');
                    }
                })
        };

        this.removePoint = $event => {
            $event.preventDefault();

            this.createRouteForm.current.setFieldsValue({
                pontos: null
            });

            this.setState({
                loading: true,
                directions: null,
                draggable: false,
                modalRemove: false,
                loadingRemovePoint: true
            }, () => {
                this.updateWayPoints(this.state.routeSelected, this.state.pointSelected);
            });
        };

        this.confirmRemoveRoute = $event => {
            $event.preventDefault();
            this.setState({ modalRemove: true, typeRemove: "route" });
        };

        this.handleLinkRoute = $event => {
            $event.preventDefault();
            this.setState({
                linkRouteButton: true,
                componentKey: this.state.componentKey + 1
            });
        }

        this.confirmRemovePoint = $event => {
            $event.preventDefault();
            this.setState({ modalRemove: true, typeRemove: "point" });
        };

        this.cancelRemove = $event => {
            $event.preventDefault();
            this.setState({ modalRemove: false, typeRemove: null })
        }

        this.saveRoute = $event => {
            $event.preventDefault();

            this.setState({
                loadingSaveRoute: true
            });

            this.serviceRoute
                .addRoute({
                    "name": this.state.nome,
                    "origDescr": this.state.inicio,
                    "origin": [
                        this.state.directions.routes[0].legs[0].start_location.lng(),
                        this.state.directions.routes[0].legs[0].start_location.lat(),
                    ],
                    "destDescr": this.state.fim,
                    "destination": [
                        this.state.directions.routes[0].legs[0].end_location.lng(),
                        this.state.directions.routes[0].legs[0].end_location.lat(),
                    ],
                    "waypoints": [],
                    "gmaps": this.state.directions,
                })
                .then(response => {
                    // O código que lida com a resposta de sucesso
                    messageSuccess("Rota adicionada com sucesso!");
                    this.setState({
                        loadingSaveRoute: false
                    });
                    // Limpar o formulário e atualizar o estado
                    this.createRouteForm.current.setFieldsValue({
                        nome: "",
                        inicio: "",
                        fim: "",
                        pontos: null
                    });
                    this.setState({
                        nome: "",
                        inicio: "",
                        fim: "",
                        routeSelected: null,
                        pointSelected: null,
                        directions: null,
                        draggable: false,
                        createNewRoute: false,
                    }, () => {
                        this.getRoutes();
                    });
                })
                .catch(erros => {
                    if (erros.response) {
                        if (erros.response.status === 401) {
                            this.auth.endSession();
                            this.props.history.push('/login');
                        } else if (erros.response.status === 413) {
                            messageError("Erro: Rota traçada maior do que o limite permitido.");
                        } else {
                            messageError("ERRO! Falha no processamento desta ação, favor repetir o processo.");
                        }
                    } else {
                        messageError("Erro inesperado, verifique sua conexão e tente novamente.");
                    }

                    this.setState({
                        loadingSaveRoute: false
                    });
                });
        };

        this.getIndex = (value, arr, prop) => {
            for (var i = 0; i < arr.length; i++) {
                if (prop === "routeId" || prop === "plateId") {
                    if (arr[i][prop] === value) {
                        return i;
                    }
                } else {
                    if (parseInt(arr[i][prop], 10) === parseInt(value, 10)) {
                        return i;
                    }
                }
            }
            return -1;
        };

        this.onChangeRoute = e => {
            this.setState({
                loading: true,
            });
            let index = this.getIndex(e, this.state.allRoutes, "routeId");
            if (index !== -1) {
                this.createRouteForm.current.setFieldsValue({
                    nome: this.state.allRoutes[index].name,
                    inicio: this.state.allRoutes[index].origDescr,
                    fim: this.state.allRoutes[index].destDescr,
                    pontos: null
                });

                this.setState({
                    nome: this.state.allRoutes[index].name,
                    inicio: this.state.allRoutes[index].origDescr,
                    fim: this.state.allRoutes[index].destDescr,
                    routeSelected: this.state.allRoutes[index],
                    pointSelected: null,
                    directions: null,
                    draggable: false,
                    addNewPoint: false
                }, () => {
                    this.getRouteById(this.state.routeSelected.routeId);
                });
            } else {
                this.setState({
                    nome: "",
                    inicio: "",
                    fim: "",
                    routeSelected: null,
                    directions: null,
                    loading: false,
                });
            }
        };

        this.onChangePoint = e => {

            if (e === 0) {
                this.setState({
                    pointSelected: null
                });
            } else if (e === this.state.sizeListWaypoints) {
                this.setState({
                    pointSelected: this.state.allPoints
                });

            } else {
                let opt = [];
                opt.push(this.state.allPoints[parseInt(e - 1, 10)]);

                this.setState({
                    pointSelected: opt
                });
            }

        };

        this.handleLinkRoutePlate = (value, plateSelected) => {
            //$event.preventDefault();
            this.setState({
                linkRoutePlate: value,
                plate: plateSelected,
            });

        }

        this.handleCreateNewRouteCard = () => {
            this.setState({
                allPoints: [],
                createNewRoute: true,
            });
        }

        this.handleBackRoutes = () => {
            this.setState({
                createNewRoute: false,
                directions: null,
            });
        }

        this.handleCloseLinkRoute = () => {
            this.setState({
                linkRouteButton: false,
            });
        }

        this.handleAddNewPoint = () => {
            this.setState({
                addNewPoint: !this.state.addNewPoint,
            });
        }

        this.handleMoveMap = () => {
            this.setState({
                addNewPoint: false,
            });
        }
    }


    render() {
        return (
            <>
                <AppLayout>
                    {this.state.loading && (
                        <Loading />
                    )}

                    <div className='teste2' style={{ position: '', left: '0px', width: '100%', overflow: 'hidden', top: '37px', right: '0px' }}>
                        <div className='teste1'>
                            <Dialog
                                className='teste3'
                                header="Confirmação"
                                onOk={this.state.typeRemove === "route" ? this.removeRoute : this.removePoint}
                                onCancel={this.cancelRemove}
                                okText="Confirmar"
                                cancelText="Cancelar"
                                visible={this.state.modalRemove}
                                style={{ width: '50vw' }}
                                modal={true}
                                onHide={() => this.setState({ modalRemove: false, typeRemove: null })}
                            >
                                {this.state.typeRemove === "route" ? "Deseja realmente efetuar a exclusão desta rota?" : "Deseja realmente efetuar a exclusão deste ponto?"}
                            </Dialog>
                        </div>

                        {this.state.createNewRoute === false ? (
                            <div>
                                <Card title="Rotas Cadastradas">
                                    <Form ref={this.createRouteForm} layout="vertical" style={{ height: 80 }}>
                                        <Row>
                                            <Col xs={24} sm={24} md={12} lg={6} xl={6}>
                                                <Form.Item label={<b style={{ fontSize: '15px', fontWeight: 500 }}>Rotas</b>} name="rotas">
                                                    <Select
                                                        disabled={this.state.loading}
                                                        showSearch
                                                        filterOption={(input, option) =>
                                                            option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                        }
                                                        filterSort={(optionA, optionB) =>
                                                            optionA.label.toLowerCase().localeCompare(optionB.label.toLowerCase())
                                                        }
                                                        allowClear
                                                        onClear={() => {
                                                            this.createRouteForm.current.setFieldsValue({
                                                                rotas: null,
                                                                nome: null,
                                                                inicio: null,
                                                                fim: null,
                                                                pontos: null,

                                                            });
                                                            this.setState({
                                                                linkRouteButton: false,
                                                                loadingSaveRoute: false,
                                                                addNewPoint: false
                                                            })
                                                        }}

                                                        placeholder='Rotas'
                                                        onChange={this.onChangeRoute}
                                                        options={this.state.routes ? this.state.routes : ""}
                                                        style={{ width: '90%' }}
                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col xs={24} sm={24} md={12} lg={6} xl={6}>
                                                <Form.Item label={<b style={{ fontSize: '15px', fontWeight: 500 }}>Início</b>} name="inicio">
                                                    <Input disabled placeholder='Início' name='inicio' value={this.state.inicio} onChange={e => this.setState({ inicio: e.target.value, directions: null })} style={{ width: '90%' }} />
                                                </Form.Item>
                                            </Col>
                                            <Col xs={24} sm={24} md={12} lg={6} xl={6}>
                                                <Form.Item label={<b style={{ fontSize: '15px', fontWeight: 500 }}>Fim</b>} name="fim">
                                                    <Input disabled placeholder='Fim' name='fim' value={this.state.fim} onChange={e => this.setState({ fim: e.target.value, directions: null })} style={{ width: '90%' }} />
                                                </Form.Item>
                                            </Col>

                                            {this.state.routeSelected !== null && (
                                                <Col xs={24} sm={24} md={12} lg={6} xl={6}>
                                                    <Form.Item label={<b style={{ fontSize: '15px', fontWeight: 500 }}>Pontos de Parada</b>} name="pontos">
                                                        <Select
                                                            disabled={this.state.loading}
                                                            placeholder='Selecione...'
                                                            onChange={this.onChangePoint}
                                                            allowClear
                                                            options={this.state.points ? this.state.points : ""}
                                                            style={{ width: '90%' }}
                                                        />
                                                    </Form.Item>
                                                </Col>
                                            )}

                                        </Row>
                                    </Form>

                                    <Row>
                                        <Col xs={12} sm={12} md={18} lg={18} xl={20} />

                                        {this.state.routeSelected === null && (
                                            <Col xs={12} sm={12} md={6} lg={6} xl={4} style={{ display: 'flex', justifyContent: 'end', marginTop: '20px' }}>
                                                <Button
                                                    type='primary'
                                                    icon={<PlusOutlined />}
                                                    children='Cadastrar Rota'
                                                    loading={this.state.loadingMap}
                                                    style={{ marginRight: '10px', width: '150px' }}
                                                    onClick={this.handleCreateNewRouteCard}

                                                />
                                            </Col>
                                        )}

                                        {this.state.routeSelected !== null && (
                                            <Col xs={12} sm={12} md={6} lg={6} xl={4} style={{ display: 'flex', justifyContent: 'end', marginTop: '20px' }}>
                                                <Button
                                                    title='Vincular ao Veículo'
                                                    type='primary'
                                                    icon={<DownloadOutlined />}
                                                    children='Vincular ao Veículo'
                                                    style={{ marginRight: "10px", width: '150px' }}
                                                    onClick={this.handleLinkRoute}
                                                    disabled={this.state.linkRouteButton}
                                                />
                                                <Button
                                                    title={this.state.addNewPoint ? 'Mover Mapa' : 'Adicionar Ponto'}
                                                    type='primary'
                                                    icon={this.state.addNewPoint ? <NodeIndexOutlined /> : <EnvironmentOutlined />}
                                                    children={this.state.addNewPoint ? 'Mover Mapa' : 'Adicionar Ponto'}
                                                    style={{ marginRight: "10px", width: '150px' }}
                                                    onClick={this.handleAddNewPoint}
                                                    disabled={this.state.linkRouteButton}
                                                />
                                                <Button
                                                    className='orangeButton'
                                                    title='Remover Rota'
                                                    type='primary'
                                                    icon={<DeleteOutlined />}
                                                    children='Remover Rota'
                                                    danger
                                                    loading={this.state.loadingRemoveRoute}
                                                    style={{ marginRight: '10px', width: '150px' }}
                                                    onClick={this.confirmRemoveRoute}
                                                    disabled={this.state.directions === null || !this.state.nome || !this.state.inicio || !this.state.fim || this.state.linkRouteButton}
                                                />
                                                <Button
                                                    className='orangeButton'
                                                    type='primary'
                                                    icon={<DeleteOutlined />}
                                                    children='Remover Ponto'
                                                    loading={this.state.loadingRemovePoint}
                                                    style={{ width: '150px' }}
                                                    onClick={this.confirmRemovePoint}
                                                    disabled={this.state.pointSelected === null || this.state.pointSelected === "" || this.state.linkRouteButton}
                                                />
                                            </Col>
                                        )}
                                    </Row>
                                </Card>
                            </div>
                        ) :
                            <></>}

                        {this.state.createNewRoute === true ? (
                            <div>
                                <Card
                                    title="Cadastrar Rota"
                                    extra={
                                        <ButtonAntd
                                            type="text"
                                            shape="circle"
                                            icon={<LeftOutlined />}
                                            onClick={this.handleBackRoutes}

                                        />

                                    }
                                >
                                    <Form ref={this.createRouteForm} layout="vertical" style={{ height: 80 }}>
                                        <Row>
                                            <Col xs={24} sm={24} md={12} lg={6} xl={6}>
                                                <Form.Item label={<b style={{ fontSize: '15px', fontWeight: 500 }}>Nome</b>} name="nome">
                                                    <Input disabled={this.state.loading} placeholder='Nome' name='nome' value={this.state.nome} onChange={e => this.setState({ nome: e.target.value, directions: null })} style={{ width: '90%' }} />
                                                </Form.Item>
                                            </Col>
                                            <Col xs={24} sm={24} md={12} lg={6} xl={6}>
                                                <Form.Item label={<b style={{ fontSize: '15px', fontWeight: 500 }}>Início</b>} name="inicio">
                                                    <Input disabled={this.state.loading} placeholder='Início' name='inicio' value={this.state.inicio} onChange={e => this.setState({ inicio: e.target.value, directions: null })} style={{ width: '90%' }} />
                                                </Form.Item>
                                            </Col>
                                            <Col xs={24} sm={24} md={12} lg={6} xl={6}>
                                                <Form.Item label={<b style={{ fontSize: '15px', fontWeight: 500 }}>Fim</b>} name="fim">
                                                    <Input disabled={this.state.loading} placeholder='Fim' name='fim' value={this.state.fim} onChange={e => this.setState({ fim: e.target.value, directions: null })} style={{ width: '90%' }} />
                                                </Form.Item>
                                            </Col>

                                            {this.state.routeSelected !== null && (
                                                <Col xs={24} sm={24} md={12} lg={6} xl={6}>
                                                    <Form.Item label={<b style={{ fontSize: '15px', fontWeight: 500 }}>Pontos</b>} name="pontos">
                                                        <Select
                                                            disabled={this.state.loading}
                                                            placeholder='Selecione...'
                                                            onChange={this.onChangePoint}
                                                            allowClear
                                                            options={this.state.points ? this.state.points : ""}
                                                            style={{ width: '90%' }}
                                                        />
                                                    </Form.Item>
                                                </Col>
                                            )}

                                        </Row>
                                    </Form>

                                    <Row>

                                        {this.state.routeSelected === null && (
                                            <Col xs={Row} sm={Row} md={Row} lg={24} xl={24} style={{ display: 'flex', justifyContent: 'end', marginTop: '20px' }}>
                                                <Button
                                                    type='primary'
                                                    icon={<SearchOutlined />}
                                                    children='Visualizar Rota'
                                                    loading={this.state.loadingMap}
                                                    style={{ marginRight: '10px', width: '150px' }}
                                                    onClick={this.mountRoute}
                                                    disabled={!this.state.nome || !this.state.inicio || !this.state.fim}
                                                />
                                                <Button
                                                    className='successButton'
                                                    title='Salvar Rota'
                                                    type='primary'
                                                    icon={<SaveOutlined />}
                                                    children='Salvar Rota'
                                                    loading={this.state.loadingSaveRoute}
                                                    style={{ width: '150px' }}
                                                    onClick={this.saveRoute}
                                                    disabled={this.state.directions === null || !this.state.nome || !this.state.inicio || !this.state.fim}
                                                />
                                            </Col>
                                        )}
                                    </Row>
                                </Card>
                            </div>
                        ) :
                            <></>}

                        {this.state.linkRouteButton === true ? (
                            <div style={{ marginTop: "5px" }}>
                                <LinkRoute
                                    key={this.state.componentKey}
                                    nameRota={this.state.nome}
                                    idRoute={this.state.routeSelected.routeId}
                                    linkRoutePlate={this.handleLinkRoutePlate}
                                    closeCard={this.handleCloseLinkRoute}
                                >

                                </LinkRoute>
                            </div>
                        )
                            :
                            <></>
                        }

                        {this.state.directions !== null && this.state.linkRouteButton === false && (
                            <Map
                                height="300px"
                                instance={this}
                                pointSelected={this.state.pointSelected}
                                isDrawingManager={true}
                                addUpdateToPoints={this.getUpdatedPoints}
                                addNewPoint={this.state.addNewPoint}
                                moveMap={this.handleMoveMap}
                            />
                        )}
                    </div>
                </AppLayout>
            </>
        );
    }
}
export default withRouter(CreateRoute)